import React from "react";
import { ThemeProvider } from "styled-components";
import { theme } from "./commons/constants/theme";
import Enrollment from "./components/Enrollment";
export default function App() {
    return (React.createElement(ThemeProvider, { theme: theme },
        React.createElement(Enrollment, { onSuccessCallback: function () { return console.log("success!"); } })));
}
